<app-cp-compare-sidebar-consumption *ngIf="hasElec$ | async"></app-cp-compare-sidebar-consumption>